<template>
    <v-container fluid>
        <no-data-dialog v-if="notifyDialog" @input="notifyDialog = false" />
        <v-dialog v-model="dialog" max-width="500px">
            <audit-form :filter="auditFilter" v-model="audit" v-on:save="dialog = false" v-on:delete="onDelete" v-on:cancel="dialog = false" />
        </v-dialog>
        <v-row>
            <v-col sm="auto">
                <h2>Member: {{ memberName }} {{ membershipNumber }}</h2>
            </v-col>
            <v-col sm="auto">
                <v-btn color="tertiary" dark class="ml-2 float-right" @click="dialog = true">Edit Audit Details</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-tabs v-model="recordTab">
                    <v-tab v-for="(tab, i) in tabs" @change="refreshTab(i)" :key="tab.title">
                        {{ tab.title }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="recordTab">
                    <v-tab-item v-for="(tab, i) in tabs" :key="tab.title + '1'">
                        <v-card>
                            <component :is="tab.table" :show-expand="true" :filter="recordFilter" :is-audit="true" :refresh-key="tabs[i].key" :readonly="true" />
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import exporter from '../export/exporter'

    export default {
        props: [
            'filter'
        ],
        components: {
            noDataDialog: () => import('../export/NoDataDialog'),
            auditForm: () => import('../forms/AuditForm')
        },

        data() {
            return {
                tabs: [
                    { title: 'Sites', table: () => import('../tables/SitesTable'), key: 0 },
                    { title: 'Loads', table: () => import('../tables/LoadsTable'), key: 0 },
                    { title: 'Load Movements', table: () => import('../tables/LoadMovementsTable'), key: 0 },
                    { title: 'Feedings', table: () => import('../tables/FeedingsTable'), key: 0 },
                    { title: 'Queen Purchases', table: () => import('../tables/QueenPurchasesTable'), key: 0 },
                    { title: 'Container Tests', table: () => import('../tables/ContainerTestsTable'), key: 0 },
                    { title: 'Inspections', table: () => import('../tables/InspectionsTable'), key: 0 },
                    { title: 'Treatments', table: () => import('../tables/TreatmentsTable'), key: 0 },
                    { title: 'Pest Control', table: () => import('../tables/PestControlsTable'), key: 0 },
                    { title: 'Facilities', table: () => import('../tables/FacilitiesTable'), key: 0 },
                    { title: 'Harvestings', table: () => import('../tables/HarvestingsTable'), key: 0 },
                    { title: 'Containers', table: () => import('../tables/ContainersTable'), key: 0 },
                    { title: 'Packer Containers', table: () => import('../tables/PackerContainersTable'), key: 0 },
                    { title: 'Blends', table: () => import('../tables/BlendsTable'), key: 0 },
                    { title: 'Sales', table: () => import('../tables/SalesTable'), key: 0 },
                ],
                recordTab: null,
                notifyDialog: false,
                membershipNumber: null,
                memberName: null,
                memberId: null,
                audit: null,
                dialog: false,
            }
        },

        async mounted() {
            var auditResponse = await axios.get('/api/Audits/' + this.filter.id)
            this.audit = auditResponse.data;
            this.memberId = this.audit.memberId;
            var memberResponse = await axios.get('/api/Members/' + this.memberId);
            var member = memberResponse.data;
            this.membershipNumber = member.membershipNumber;
            var contactResponse = await axios.get('/api/Contacts/' + member.contactId);
            this.memberName = contactResponse.data.contact.name;
        },

        methods: {
            async download() {
                var response = await axios.get('/api/Audits/Export/' + this.memberId);
                var items = response.data;
                var title = "Audit";

                exporter.downloadAsExcel({ title, items });
            },
            onDelete() {
                this.$router.go(-1);
            },
            refreshTab(index) {
                this.$set(this.tabs[index], 'key', this.tabs[index].key + 1);
            }
        },

        computed: {
            recordFilter() {
                return { memberId: this.memberId };
            },
            auditFilter() {
                return { ...this.filter, memberId: this.memberId };
            }
        }
    };
</script>
